/* Swipers */
var swiperHero = new Swiper(".swiper.is-hero-swiper", {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  },
  speed: 500,
});

var swiperProductCarousel = new Swiper(".swiper.is-product-carousel", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  },
  speed: 500,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 4,
    }
  },
});

var swiperWhy = new Swiper(".swiper.is-why", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  },
  speed: 500,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 3,
    }
  },
});

var swiperTestimonials = new Swiper(".swiper.is-testimonials", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  },
  speed: 500,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 4,
    }
  },
});

var swiperUGC = new Swiper(".swiper.is-ugc", {
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
  speed: 500,
  autoplay: true,
});

var swiperThumbs = new Swiper(".swiper.is-pdp-thumbs", {
  slidesPerView: 5,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
  speed: 500,
  slideToClickedSlide: true,
  watchSlidesProgress: true,
  on: {
    touchEnd: function(s,e) {
      let range = 5;
      let diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY 
                   - s.touches.startY
      if (diff < range || diff > -range) s.allowClick = true;
    }
  },
});

var swiperPDP = new Swiper(".swiper.is-pdp", {
  slidesPerView: 1,
  spaceBetween: 20,
  effect: 'fade',
  thumbs: {
    swiper: swiperThumbs
  },
  speed: 500,
});

var swiperUGC = new Swiper(".swiper.is-pdp-benefits", {
  slidesPerView: 1,
  loop: true,
  speed: 500,
  autoplay: true,
  effect: 'fade',
});

/* FAQs */

var acc = document.getElementsByClassName("faqs-item");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      if (this.classList.contains('open')) {
        this.classList.toggle('open');
      } else {
        $('.faqs-item').removeClass('open');
        this.classList.toggle('open');
      }
    });
  }

/* Marquee Scroller */  

  const init = () => {
  const marquee = document.querySelector('[wb-data="marquee"]');
  if (!marquee) {
    return;
  }
  const duration = parseInt(marquee.getAttribute("duration"), 10) || 5;
  const marqueeContent = marquee.firstElementChild;
  if (!marqueeContent) {
    return;
  }
  const marqueeContentClone = marqueeContent.cloneNode(true);
  marquee.append(marqueeContentClone);
  let tween;
  const playMarquee = () => {
    let progress = tween ? tween.progress() : 0;
    tween && tween.progress(0).kill();
    const width = parseInt(
      getComputedStyle(marqueeContent).getPropertyValue("width"),
      10
    );
    const gap = parseInt(
      getComputedStyle(marqueeContent).getPropertyValue("column-gap"),
      10
    );
    const distanceToTranslate = -1 * (gap + width);
    tween = gsap.fromTo(
      marquee.children,
      { x: 0 },
      { x: distanceToTranslate, duration, ease: "none", repeat: -1 }
    );
    tween.progress(progress);
    console.log({ width });
  };
  playMarquee();
  function debounce(func) {
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(
        () => {
          func();
        },
        500,
        event
      );
    };
  }
  window.addEventListener("resize", debounce(playMarquee));
  // console.log({ marquee, marqueeContent });
};
document.addEventListener("DOMContentLoaded", init);

/* Floating CTA */

gsap.registerPlugin(ScrollTrigger);

// Add "active" when .floating-cta hits bottom of viewport
ScrollTrigger.create({
  trigger: ".floating-cta",
  start: "bottom bottom", // element bottom hits viewport bottom
  onEnter: () => {
    document.querySelector(".floating-cta").classList.add("active");
  },
  onLeaveBack: () => {
    document.querySelector(".floating-cta").classList.remove("active");
  }
});

// Remove "active" when footer hits bottom of viewport
ScrollTrigger.create({
  trigger: ".shopify-section-group-footer-group",
  start: "top bottom",
  onEnter: () => {
    document.querySelector(".floating-cta").classList.remove("active");
  },
  onLeaveBack: () => {
    document.querySelector(".floating-cta").classList.add("active");
  }
});

/* Rebuy cart — inject selling plan (subscription cadence) below variant title */
(function () {
  const PLAN_CLASS = 'bt-selling-plan-name';
  let injectTimer = null;

  function injectPlanNames() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        // Build a map: variantTitle → sellingPlanName (for subscriptions only)
        // Key is variant_title as shown in the cart (e.g. "Watermelon / 3 Bag")
        const planMap = {};
        cart.items.forEach((item) => {
          if (item.selling_plan_allocation && item.variant_title) {
            planMap[item.variant_title] = item.selling_plan_allocation.selling_plan.name;
          }
        });

        document.querySelectorAll('.rebuy-cart__flyout-item').forEach((el) => {
          const variantTitleEl = el.querySelector('.rebuy-cart__flyout-item-variant-title');
          if (!variantTitleEl) return;

          const variantTitle = variantTitleEl.textContent.trim();
          const planName = planMap[variantTitle];

          // Remove any previously injected node so we don't duplicate
          const existing = el.querySelector('.' + PLAN_CLASS);
          if (existing) existing.remove();

          if (planName) {
            const node = document.createElement('div');
            node.className = PLAN_CLASS;
            node.textContent = planName;
            node.style.cssText = 'color:#fff;font-size:1rem;margin-top:2px;opacity:0.85;';
            variantTitleEl.after(node);
          }
        });
      })
      .catch(() => {});
  }

  // Debounce so rapid DOM mutations don't hammer /cart.js
  function scheduleInject() {
    clearTimeout(injectTimer);
    injectTimer = setTimeout(injectPlanNames, 300);
  }

  function watchRebuyCart() {
    const tryAttach = () => {
      const cart = document.querySelector('[class*="rebuy-cart__flyout"]');
      if (cart) {
        new MutationObserver(scheduleInject).observe(document.body, { childList: true, subtree: true });
        injectPlanNames();
      } else {
        // Rebuy not rendered yet — watch body until it appears
        const bodyObserver = new MutationObserver((_, obs) => {
          if (document.querySelector('[class*="rebuy-cart__flyout"]')) {
            obs.disconnect();
            new MutationObserver(scheduleInject).observe(document.body, { childList: true, subtree: true });
            injectPlanNames();
          }
        });
        bodyObserver.observe(document.body, { childList: true, subtree: true });
      }
    };
    tryAttach();
  }

  document.addEventListener('DOMContentLoaded', watchRebuyCart);
})();